// extracted by mini-css-extract-plugin
export default {"photoCredit":"photoCredit__ZGE5N"};